import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface AISummaryCardProps {
  summary: string;
  className?: string;
}
export function AISummaryCard({
  summary,
  className = ''
}: AISummaryCardProps) {
  const {
    isLight
  } = useTheme();
  return <div className={`backdrop-blur-xl border rounded-2xl p-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 shadow-sm' : 'bg-dark-card/80 border-white/10 shadow-lg'} ${className}`} data-id="element-291">
      <div className="flex items-center gap-2 mb-3" data-id="element-292">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center border ${isLight ? 'bg-vexu/10 border-vexu/20' : 'bg-vexu/10 border-vexu/20'}`} data-id="element-293">
          <Sparkles className={`w-4 h-4 ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-294" />
        </div>
        <span className={`text-xs font-bold uppercase tracking-wider ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-295">
          AI Summary
        </span>
      </div>
      <p className={`text-sm leading-relaxed ${isLight ? 'text-slate-600' : 'text-zinc-300'}`} data-id="element-296">
        {summary}
      </p>
    </div>;
}